export const aboutData = {
    title: "Who I am",
    description1: "A Self-Motivated developer with a special skill in understaing any technology quickly.",
    description2: " A Team worker with the ability to support my team at any time of crisis.",
    image: 2
}